const isPrerenderUserAgent = /Prerender/i.test(navigator.userAgent);
export default isPrerenderUserAgent;
